"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOptimizedImage;

var _resize = require("FileManagerCore/utils/resize");

function getOptimizedImage(file, imageOptimizationSetting) {
  var optimizableUrlKeys = ['url', 'friendly_url', 'alt_url'];
  var resizeParams = {
    width: parseInt(file.get('width'), 10) - 1,
    quality: imageOptimizationSetting
  };
  return optimizableUrlKeys.reduce(function (optimizedFile, urlKey) {
    return optimizedFile.set(urlKey, (0, _resize.resize)(file.get(urlKey), resizeParams));
  }, file);
}

module.exports = exports.default;